import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.title.primary
    },
    title: {
      margin: 0,
      fontSize: '36px',
      fontWeight: 600,
      marginBottom: '10px'
    },
    ingredient: {
      marginBottom: '0px'
    },
    list: {
      marginLeft: '25px'
    },
    caption: {
      fontSize: '12px',
      fontStyle: 'italic'
    },
    emoji: {
      fontStyle: 'initial'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
